module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagDialog.tagNotFound":"There is no remaining reference to this tag within the last 13 months of usage."}}')
  delete Component.options._Ctor
}
